import React from 'react';
const IconMiscFireFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4899 2.32L11.8999 1.34C9.9299 2.52 3.3999 7.03 3.3999 14C3.3999 18.69 7.2099 22.5 11.8999 22.5C16.5899 22.5 20.3999 18.69 20.3999 14C20.3999 10.63 18.9299 8.42 17.7499 6.44C16.4299 8.6 15.8899 10 13.8999 10C11.1699 10 10.5099 7.25 11.2999 5.51C11.8699 4.25 12.3899 3.66 13.4899 2.32Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscFireFill;